// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3r5iA","icon":"style_icon__37Aez","title":"style_title__24pDv"};